import {createReducer, on} from '@ngrx/store';
import * as RegisterActions from '../actions/register.actions';

export const registerFeatureKey = 'register';

export interface State {
  success: boolean;
  showConfirm: boolean;
  error: {
    code: number,
    message: string
  },
  userID: number,
  loading: boolean;
}

export const initialState: State = {
  success: false,
  showConfirm: false,
  error: null,
  loading: false,
  userID: null
};


export const reducer = createReducer(
  initialState,
  on(RegisterActions.loadRegisters, state => state),
  on(RegisterActions.registerNewUser, (state) => ({...state, loading: true, showConfirm: false, error: null})),
  on(RegisterActions.registerNewUserConfirm, (state) => ({...state, loading: false, showConfirm: true, success: true})),
  on(RegisterActions.registerNewUserPreConfirm, (state) => ({...state, loading: false, showConfirm: true, success: true})),
  on(RegisterActions.registerNewUserSuccess, (state) => ({...state, loading: false, showConfirm: false, success: true})),
  on(RegisterActions.registerNewUserFailed, (state, action) => ({
    ...state,
    loading: false,
    showConfirm: false,
    success: false,
    error: {...state.error, code: action.code, message: action.error}
  })),
);

